import { IssueTrackerFileDTO } from "./issue-tracker-file-dto";

export class IssueTrackerIncidenceDataDTO
{
    IdData: string;
    IdIncidence: string;
    CreationDate: Date;
    Message: string;
    IsInternal: boolean;
    MessageFromUser: boolean;
    FileAttached: IssueTrackerFileDTO;
    UserName: string;
}

export class IssueTrackerIncidenceDataPostDTO
{
    IdIncidence: string;
    Message: string;
    IsInternal: boolean;
    FileAttachedFile: File;
}